module.exports = __webpack_public_path__ + "static/media/Ayanna_Howard.4d8bb838.jpg";